import { requestJson } from '../common/http';
import type { ApplyWorkLogEntriesCommand, ApplyWorkLogEntriesResult, MonthWorkLog } from './models';

export const applyWorkLogs = (cmd: ApplyWorkLogEntriesCommand): Promise<ApplyWorkLogEntriesResult> =>
    requestJson<ApplyWorkLogEntriesResult>({
        method: 'POST',
        path: '/work-log-entries/apply',
        body: cmd,
    });

export const getWorkLogsByDate = async (teamMemberId: string, year: number, month: number): Promise<MonthWorkLog[]> => {
    const { items } = await requestJson<{ items: MonthWorkLog[] }>({
        method: 'GET',
        path: '/work-log-entries',
        query: { queryType: 'ByDate', teamMemberId, year, month },
    });
    return items;
};
